module.exports = __webpack_public_path__ + "static/media/termsLogo.e4dc86d8.svg";